__turbopack_context__.v({
  "container": "LogoutClient-module-scss-module__PxOBEG__container",
  "content": "LogoutClient-module-scss-module__PxOBEG__content",
});
